import {
  AirExchangeForTypeEnum,
  ExchangeActionEnum,
} from "@b2bportal/air-exchange-api";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface SearchInitialState {
  exchangeFor: AirExchangeForTypeEnum;
  outboundSelection: ExchangeActionEnum;
  returnSelection?: ExchangeActionEnum;
}

const SLICE_NAME = "exchangeSearch";

const initialState: SearchInitialState = {
  exchangeFor: AirExchangeForTypeEnum.RoundTrip,
  outboundSelection: ExchangeActionEnum.Keep,
  returnSelection: undefined,
};

const searchSlice = createSlice({
  initialState,
  name: SLICE_NAME,
  reducers: {
    setExchangeFor(state, action: PayloadAction<AirExchangeForTypeEnum>) {
      state.exchangeFor = action.payload;
    },
    setOutboundSelection(state, action: PayloadAction<ExchangeActionEnum>) {
      state.outboundSelection = action.payload;
    },
    setReturnSelection(
      state,
      action: PayloadAction<ExchangeActionEnum | undefined>
    ) {
      state.returnSelection = action.payload;
    },
  },
});

export { initialState as searchInitialState };
export const { setExchangeFor, setOutboundSelection, setReturnSelection } =
  searchSlice.actions;
export default searchSlice.reducer;
